import React, {useContext, useEffect, useState} from "react";
import {Image, Linking, Modal, Platform, ScrollView} from 'react-native';
import Div from "../lib/Div";
import MainStyle from "../../MainStyle";
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import Btn from "../components/Btn";
import {LinearGradient} from "expo-linear-gradient";
import AntDesign from "@expo/vector-icons/AntDesign";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {useNavigation} from "@react-navigation/native";
import {StoreContext} from "../components/StoreContextProvider";
import P from "../lib/P";
import menuNotifications from "../assets/img/icons/menu-notifications.svg";
import Switch from "../components/Switch";
import {ActivePromoTypes, ActiveStationIds, dateFormat, StartingPage, thumbStyle, trackStyle} from "../constants";
import type {LegalDocumentType, updateUserPayloadType} from "../types";
import moment from "moment";
import ServiceClient from "../utils/ServiceClient";
import {ConfirmModal} from "./ConfirmModal";
import AsyncStorage from "@react-native-async-storage/async-storage";
import MoneyBills from "../assets/img/icons/money-bills.svg";
import MoneyBillTransfer from "../assets/img/icons/money-bill-transfer.svg";
import LegalDocumentModal from "./LegalDocumentModal";

const support_url = "https://smgames.atlassian.net/servicedesk/customer/portal/3";

const MenuModal = () => {
  const [visible, setVisible] = useState(false);
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const Context = useContext(StoreContext);
  const {user, cancelModalConfig, stationId} = Context;
  const [expandNotifications, setExpandNotifications] = useState(false);
  const [expandLegal, setExpandLegal] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [promoType, setPromoType] = useState('');
  const [legalDocument, setLegalDocument] = useState<LegalDocumentType | null>(null);

  const Logout = () => {
    Context.logout().then(() => {
      setShowSignOutModal(false);
      setTimeout(() => {
        if (Platform.OS === "web") window.location.reload();
      }, 150);
      navigation.reset({index: 0, routes: [{name: StartingPage}]});
    });
  };

  const onChange = (field: 'text' | 'email' | 'partner') => () => {
    if (!user) return;
    Context.setLoadingOverlay(true);

    const {username, allowTextNotifications, allowEmailNotifications, allowPartnerPromos, handicap, handedness} = user;
    const {firstname, lastname, dateOfBirth, gender} = user;

    const payload: updateUserPayloadType = {
      username, allowTextNotifications, allowEmailNotifications, allowPartnerPromos, handicap, handedness, firstname,
      lastname, dateOfBirth: moment(dateOfBirth, dateFormat).format(), gender
    };

    if (field === 'text') payload.allowTextNotifications = !payload.allowTextNotifications;
    else if (field === 'email') payload.allowEmailNotifications = !payload.allowEmailNotifications;
    else if (field === 'partner') payload.allowPartnerPromos = !payload.allowPartnerPromos;

    ServiceClient.updateUser(payload).then(() => {
      getUser();

    }).catch(err => {
      console.log('updateUser err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });
    });
  };

  const getUser = () => {
    Context.getUser().then(() => {
      Context.setLoadingOverlay(false);

    }).catch(err => {
      console.log('getUser err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });
    });
  };

  const navigateTo = (screen: string, params?: object) => () => {
    setVisible(false);
    navigation.navigate({name: screen, params});
  };

  const openLegalDocument = (documentType: LegalDocumentType) => () => {
    setLegalDocument(documentType);
  };

  useEffect(() => {
    AsyncStorage.getItem('promoType').then(res => {
      if (res) setPromoType(res);
    });
  }, []);

  // React Native Modal toggles via the `visible` prop without unmounting its
  // children, so dropdown state survives close/reopen. Reset on every open so
  // the menu always lands in a fresh, collapsed state.
  useEffect(() => {
    if (visible) {
      setExpandNotifications(false);
      setExpandLegal(false);
    }
  }, [visible]);

  return (
    <Div>
      <Btn testID="menu-open" w={28} h={28} bg="#252526" rounded={50} alignItems="center" justifyContent="center"
           onPress={() => setVisible(true)}>
        <FontAwesome5 name="equals" size={16} color="white"/>
      </Btn>

      <Modal visible={visible} animationType="fade" onRequestClose={() => setVisible(false)}>
        <LinearGradient colors={['#000000', '#252526']} start={{x: 0.5, y: 0}} end={{x: 0.5, y: 1}}
                        style={MainStyle.flex1}>
          <Div row pt={12} px={16}>
            <Div flex={1}/>
            <Btn testID="menu-close" w={28} h={28} bg="#252526" onPress={() => setVisible(false)} alignItems="center"
                 justifyContent="center" rounded={15}>
              <AntDesign name="close" size={16} color="white"/>
            </Btn>
          </Div>

          <P ta="center" fontFamily="DavisSans-Medium" fs={20} lh={30} mb={40}>Hey, {user?.firstname || 'Guest'}</P>

          <ScrollView contentContainerStyle={MainStyle.flex1} scrollEventThrottle={16}>
            <Div bg="#252526">
              <Btn h={56} px={16} row alignItems="center" onPress={() => {
                setVisible(false);
                Context.setShowProfileModal(true);
              }}>
                <FontAwesome5 name="user" size={16} color="white" style={[MainStyle.w_20, MainStyle.t_a_c]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>My Profile</P>
              </Btn>

              <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

              <Btn h={56} px={16} row alignItems="center" onPress={navigateTo('challenges')}>
                <FontAwesome5 name="golf-ball" size={16} color="white" style={[MainStyle.w_20, MainStyle.t_a_c]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>Play</P>
              </Btn>

              <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

              {(ActivePromoTypes.includes(promoType) || ActiveStationIds.includes(stationId)) && (
                <>
                  <Btn h={56} px={16} row alignItems="center" onPress={navigateTo('tournaments')}>
                    <FontAwesome5 name="trophy" size={16} color="white" style={[MainStyle.w_20, MainStyle.t_a_c]}/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Tournaments</P>
                  </Btn>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>
                </>
              )}

              {/*<Btn h={56} px={16} row alignItems="center" onPress={navigateTo('FriendsScreen')}>*/}
              {/*  <FontAwesome5 name="user-friends" size={16} color="white"/>*/}
              {/*  <P fontFamily="DavisSans-Regular" ml={12}>Play With Friends</P>*/}
              {/*</Btn>*/}

              {/*<Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>*/}

              {/*<Btn h={56} px={16} row alignItems="center" onPress={navigateTo('TournamentSeries')}>*/}
              {/*  <FontAwesome5 name="award" size={16} color="white"/>*/}
              {/*  <P fontFamily="DavisSans-Regular" ml={12}>Tournament Series</P>*/}
              {/*</Btn>*/}

              {/*<Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>*/}

              <Btn h={56} px={16} row alignItems="center" onPress={navigateTo('account', {step: 1})}>
                <Image source={MoneyBills as any} style={[MainStyle.w_20, MainStyle.h_14]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>Wallet</P>
              </Btn>

              <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

              <Btn h={56} px={16} row alignItems="center" onPress={navigateTo('TransactionHistory')}>
                <Image source={MoneyBillTransfer as any} style={[MainStyle.w_20, MainStyle.h_14]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>Transaction History</P>
              </Btn>

              <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

              <Btn h={56} px={16} row alignItems="center" onPress={() => setExpandNotifications(!expandNotifications)}>
                <Div w={20} alignItems="center">
                  <Image source={menuNotifications as any} style={[MainStyle.w_14, MainStyle.h_15]}/>
                </Div>
                <P fontFamily="DavisSans-Regular" ml={12}>Notification Settings</P>

                <Div flex={1}/>
                <FontAwesome5 name={`chevron-${expandNotifications ? 'up' : 'down'}`} size={18} color="white"/>
              </Btn>

              {expandNotifications ? (
                <Div bg="#323332">
                  <Div h={56} pr={16} row alignItems="center" pl={32}>
                    <P fontFamily="DavisSans-Regular">Text</P>
                    <Div flex={1}/>
                    <Switch
                      value={user?.allowTextNotifications} trackStyle={trackStyle} thumbStyle={thumbStyle}
                      onPress={onChange('text')}
                    />
                  </Div>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Div h={56} pr={16} row alignItems="center" pl={32}>
                    <P fontFamily="DavisSans-Regular">Email</P>
                    <Div flex={1}/>
                    <Switch
                      value={user?.allowEmailNotifications} trackStyle={trackStyle} thumbStyle={thumbStyle}
                      onPress={onChange('email')}
                    />
                  </Div>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Div h={56} pr={16} row alignItems="center" pl={32}>
                    <P fontFamily="DavisSans-Regular">Partner Promos</P>
                    <Div flex={1}/>
                    <Switch
                      value={user?.allowPartnerPromos} trackStyle={trackStyle} thumbStyle={thumbStyle}
                      onPress={onChange('partner')}
                    />
                  </Div>
                </Div>
              ) : <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>}

              <Btn h={56} px={16} row alignItems="center" onPress={() => setExpandLegal(!expandLegal)}>
                <FontAwesome5 name="balance-scale" size={16} color="white" style={[MainStyle.w_20, MainStyle.t_a_c]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>Legal</P>

                <Div flex={1}/>
                <FontAwesome5 name={`chevron-${expandLegal ? 'up' : 'down'}`} size={18} color="white"/>
              </Btn>

              {expandLegal ? (
                <Div bg="#323332">
                  <Btn h={56} pr={16} row alignItems="center" pl={32} onPress={openLegalDocument('TermsAndConditions')}>
                    <FontAwesome5 name="file-alt" size={16} color="white"/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Terms and Conditions</P>
                  </Btn>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Btn h={56} pr={16} row alignItems="center" pl={32} onPress={openLegalDocument('PrivacyPolicy')}>
                    <FontAwesome5 name="file-alt" size={16} color="white"/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Privacy Policy</P>
                  </Btn>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Btn h={56} pr={16} row alignItems="center" pl={32} onPress={openLegalDocument('ResponsibleGaming')}>
                    <FontAwesome5 name="file-alt" size={16} color="white"/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Responsible Gaming</P>
                  </Btn>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Btn h={56} pr={16} row alignItems="center" pl={32} onPress={openLegalDocument('SelfExclusion')}>
                    <FontAwesome5 name="file-alt" size={16} color="white"/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Self-Limitation</P>
                  </Btn>

                  <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>

                  <Btn h={56} pr={16} row alignItems="center" pl={32} onPress={openLegalDocument('Promotions')}>
                    <FontAwesome5 name="file-alt" size={16} color="white"/>
                    <P fontFamily="DavisSans-Regular" ml={12}>Promotions Terms and Conditions</P>
                  </Btn>
                </Div>
              ) : <Div bg="#BBBCBF" opacity={0.15} h={1} ml={16}/>}

              <Btn h={56} px={16} row alignItems="center" onPress={() => {
                if (Platform.OS === "web") window.open(support_url, '_blank');
                else Linking.openURL(support_url).then();
                setVisible(false);
              }}>
                <FontAwesome5 name="question-circle" size={16} color="white" style={[MainStyle.w_20, MainStyle.t_a_c]}/>
                <P fontFamily="DavisSans-Regular" ml={12}>Contact Support</P>
              </Btn>
            </Div>
          </ScrollView>

          <Btn h={56} px={16} row alignItems="center" bg="#323332" onPress={() => setShowSignOutModal(true)}>
            <FontAwesome5 name="sign-out-alt" size={23} color="#F56E6E"/>
            <P fontFamily="DavisSans-Regular" ml={12}>Sign out</P>
          </Btn>

          <ConfirmModal
            isOpen={showSignOutModal} onClose={() => setShowSignOutModal(false)}
            title="Sign Out" message="Are you sure you want to sign out?" cancelText="Back"
            affirmativeButton={{text: "Sign Out", backgroundColor: "#d03834", onPress: Logout}}
          />
        </LinearGradient>
      </Modal>

      <LegalDocumentModal documentType={legalDocument} onBack={() => setLegalDocument(null)}/>
    </Div>
  );
};

export default MenuModal;
